(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["phaze-complete-fit-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('phaze-fit-rail')) {
    customElements.define('phaze-fit-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.track = this.querySelector('[data-rail-track]');
        this.previousButton = this.querySelector('[data-rail-previous]');
        this.nextButton = this.querySelector('[data-rail-next]');
        if (!this.track || !this.previousButton || !this.nextButton) return;
        const signal = this.controller.signal;
        this.previousButton.addEventListener('click', () => this.move(-1), { signal });
        this.nextButton.addEventListener('click', () => this.move(1), { signal });
        this.addEventListener('click', event => this.onCardClick(event), { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.closePickers();
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closePickers();
        }, { signal });
        this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        const card = this.track.querySelector('.pw-fit-rail__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.75;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      onCardClick(event) {
        const variantButton = event.target.closest('[data-variant-id]');
        if (variantButton && this.contains(variantButton)) {
          event.preventDefault();
          event.stopPropagation();
          this.addVariant(variantButton);
          return;
        }

        const toggle = event.target.closest('[data-picker-toggle]');
        if (!toggle || !this.contains(toggle)) return;
        event.preventDefault();
        event.stopPropagation();
        const card = toggle.closest('.pw-fit-rail__card');
        const willOpen = card?.dataset.pickerOpen !== 'true';
        this.closePickers(card);
        if (!card) return;
        card.dataset.pickerOpen = String(willOpen);
        toggle.setAttribute('aria-expanded', String(willOpen));
        toggle.setAttribute('aria-label', willOpen ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      }

      closePickers(except) {
        this.querySelectorAll(".pw-fit-rail__card[data-picker-open='true']").forEach(card => {
          if (card === except) return;
          card.dataset.pickerOpen = 'false';
          const toggle = card.querySelector('[data-picker-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', toggle.dataset.openLabel);
          }
        });
      }

      async addVariant(button) {
        const card = button.closest('.pw-fit-rail__card');
        if (!card || card.dataset.loading === 'true' || button.dataset.available !== 'true') return;
        const status = card.querySelector('[data-card-status]');
        const root = window.Shopify?.routes?.root || '/';
        card.dataset.loading = 'true';
        card.setAttribute('aria-busy', 'true');
        card.querySelectorAll('[data-variant-id]').forEach(control => { control.disabled = true; });
        if (status) {
          status.dataset.error = 'false';
          status.textContent = this.dataset.adding;
        }

        let events;
        let added = false;
        try {
          events = await import('@theme/events');
          const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component'))
            .map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: button.dataset.variantId, quantity: 1 }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          added = true;
          const cart = await fetch(root + 'cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then(cartResponse => cartResponse.ok ? cartResponse.json() : undefined).catch(() => undefined);
          document.dispatchEvent(new events.CartAddEvent(cart, `phaze-fit-rail-${button.dataset.variantId}`, {
            source: 'phaze-fit-rail',
            productId: button.dataset.productId,
            itemCount: 1,
            sections: result.sections
          }));
          if (status && this.isConnected) status.textContent = this.dataset.added;
          card.dataset.pickerOpen = 'false';
          const toggle = card.querySelector('[data-picker-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', toggle.dataset.openLabel);
          }
          button.blur();
          if (!document.querySelector('cart-drawer-component')) window.location.assign(root + 'cart');
        } catch (error) {
          if (status && this.isConnected) {
            status.dataset.error = 'true';
            status.textContent = error.message || this.dataset.error;
          }
          if (events && !added) {
            const cart = await fetch(root + 'cart.js', {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            }).then(cartResponse => cartResponse.ok ? cartResponse.json() : undefined).catch(() => undefined);
            if (cart) {
              document.dispatchEvent(new events.CartUpdateEvent(cart, `phaze-fit-rail-${button.dataset.variantId}`, {
                source: 'phaze-fit-rail',
                didError: true
              }));
            }
          }
        } finally {
          card.dataset.loading = 'false';
          card.setAttribute('aria-busy', 'false');
          card.querySelectorAll('[data-variant-id]').forEach(control => {
            control.disabled = control.dataset.available !== 'true';
          });
        }
      }

      update() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const scrollable = maxScroll > 2;
        this.dataset.scrollable = String(scrollable);
        this.previousButton.disabled = !scrollable || this.track.scrollLeft <= 2;
        this.nextButton.disabled = !scrollable || this.track.scrollLeft >= maxScroll - 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
